import React, { useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { ssoSignOut } from "../../actions/AuthActions";
import IdleTimer from 'react-idle-timer';
import { connect } from "react-redux";
import Countdown from 'react-countdown';

const IdleAlert = props => {
    const [showModal, setShowModal] = useState(false);
    const idleTimerRef = useRef(null);
    const sesssionTimeoutRef = useRef(null);

    const MODAL_EXPIRE =  120000; //2 minutes
    const SESSION_EXPIRE = 780000; //13 minutes

    const idleWarning = event => {
        setShowModal(true);
        sesssionTimeoutRef.current = setTimeout(logout, MODAL_EXPIRE);
    }

    const stayActive = () => {
        clearTimeout(sesssionTimeoutRef.current)
        setShowModal(false);
    }

    const logout = () => {
        clearTimeout(sesssionTimeoutRef.current);
        setShowModal(false);
        props.ssoSignOut();
    }

    const timeoutText = ({ minutes, seconds,  }) => {
        var leadingZero = "0";
        var customMinutes = minutes;
        var customSeconds = seconds;

        if(minutes < 10){
            customMinutes = leadingZero.concat(minutes);
        }

        if(seconds < 10){
            customSeconds = leadingZero.concat(seconds);
        }


        return <span>Your session is about to expire. You will automatically be logged out in: <strong>{customMinutes}:{customSeconds}</strong></span>;
    };

    return (
        <div>
            <IdleTimer
                ref={idleTimerRef}
                timeout={SESSION_EXPIRE}
                onIdle={idleWarning}
                debounce={250}
            />
            <Modal
                backdrop="static"
                keyboard={false}
                size="lg"
                show={showModal}
                centered
            >
                <Modal.Header>
                    <Modal.Title>Need More Time?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>
                            <Countdown
                                date={Date.now() + MODAL_EXPIRE}
                                renderer={timeoutText}
                            />
                        </p>
                        <p>To continue your session, select <strong>Stay Signed In</strong></p>
                    </div>
                </Modal.Body>
            <Modal.Footer>
                <Button
                    className="ml-1"
                    onClick={stayActive}
                    type="button"
                    variant="success"
                >
                    Stay Signed In
                </Button>
                <Button
                    onClick={logout}
                >
                    Log Out
                </Button>
            </Modal.Footer>
            </Modal>
        </div >
    )
}


export default connect(null, { ssoSignOut })(
    IdleAlert
);
